const getToken = () => localStorage.getItem("@bovcontrol-vivo/token");

const setToken = (token: string) => {
  localStorage.setItem("@bovcontrol-vivo/token", token);
};

const deleteToken = () => {
  localStorage.removeItem("@bovcontrol-vivo/token");
};

const getIdToken = () => localStorage.getItem("@bovcontrol-vivo/id-token");

const setIdToken = (token: string) => {
  localStorage.setItem("@bovcontrol-vivo/id-token", token);
};

const deleteIdToken = () => {
  localStorage.removeItem("@bovcontrol-vivo/id-token");
};

const getUsername = () => localStorage.getItem("@bovcontrol-vivo/username");

const setUsername = (value: string) => {
  localStorage.setItem("@bovcontrol-vivo/username", value);
};

const deleteUsername = () => {
  localStorage.removeItem("@bovcontrol-vivo/username");
};

const getLanguage = () => localStorage.getItem("@bovcontrol-vivo/language");

const setLanguage = (value: string) => {
  localStorage.setItem("@bovcontrol-vivo/language", value);
};

export {
  getToken,
  setToken,
  deleteToken,
  getIdToken,
  setIdToken,
  deleteIdToken,
  getUsername,
  setUsername,
  deleteUsername,
  getLanguage,
  setLanguage,
};
